import * as types from '../types/pairingInfoTypes';
import {
    handleFlowsChange,
    handleSitesChange,
    handleSiteUpdate,
    handleFlowUpdate,
    augmentFlowsWithSiteData,
} from '../handlers/dataHandler';
import { findLicensedCps } from '../handlers/permissionsHandler';

let initialState = {
    flows: [],
    sites: [],
    licensedCps: [],
    graphQLErrors: null,
};

export default function pairingInfo(state = initialState, action) {
    switch (action.type) {
        case types.GET_FLOWS_SUCCESS:
            let flows = handleFlowsChange(action.res.data.listFlows.items || []);
            return {
                ...state,
                flows: augmentFlowsWithSiteData(flows, state.sites),
                graphQLErrors: action.err,
            };
        case types.GET_CUSTOMER_PAIR_INFO_SUCCESS:
            // console.log('GET_CUSTOMER_PAIR_INFO_SUCCESS', action.payload)
            const allSites = handleSitesChange(action.payload); // TODO: put in mapper
            return {
                ...state,
                sites: allSites,
                licensedCps: findLicensedCps(allSites) || [], // TODO: check if this is correct
                flows: augmentFlowsWithSiteData(state.flows, allSites),
                graphQLErrors: action.err,
            };
        case types.SUBSCRIBE_TO_FLOWS_UPDATE_SUCCESS:
            let updatedFlows = handleFlowUpdate(state.flows, action.data);
            return {
                ...state,
                flows: augmentFlowsWithSiteData(updatedFlows, state.sites),
                graphQLErrors: action.err,
            };
        case types.SUBSCRIBE_TO_LINKED_CP_INFO_UPDATE_SUCCESS:
            const updatedSites = handleSiteUpdate(state.sites, action.data);
            return {
                ...state,
                sites: updatedSites,
                flows: augmentFlowsWithSiteData(state.flows, updatedSites),
                graphQLErrors: action.err,
            };
        case types.ADD_FLOW_SUCCESS:
            let addFlow = handleFlowsChange([action.res.data.addFlow]);
            let augmentedFlows = augmentFlowsWithSiteData([...addFlow, ...state.flows], state.sites);
            return {
                ...state,
                flows: augmentedFlows,
            };
        case types.DELETE_FLOW_SUCCESS:
            return {
                ...state,
                flows: state.flows.filter((flow) => flow.id !== action.res.data.deleteFlow.id),
            };
        case types.ADD_FLOW:
        case types.DELETE_FLOW:
            return {
                ...state,
                graphQLErrors: null,
            };
        case types.CLEAR_SHARED_DATA:
            return {
                ...state,
                ...initialState,
            };
        case types.GET_CUSTOMER_PAIR_INFO_FAILURE:
        case types.ADD_FLOW_FAILURE:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
